import script from "./TableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./TableRow.vue?vue&type=script&setup=true&lang=js"

import "./TableRow.vue?vue&type=style&index=0&id=17e795ca&scoped=true&lang=css"

import exportComponent from "/var/www/4schemplus/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17e795ca"]])

export default __exports__